type KeyEventHandlers<T> = {
  open?: (e: React.KeyboardEvent<T>) => void;
  close?: (e: React.KeyboardEvent<T>) => void;
  navigate?: (e: React.KeyboardEvent<T>) => void;
};

type KeyEventAction<T> = keyof KeyEventHandlers<T>;

const handledKeys = {
  Enter: 'open',
  ' ': 'open',
  Escape: 'close',
  ArrowUp: 'navigate',
  ArrowDown: 'navigate',
  ArrowLeft: 'navigate',
  ArrowRight: 'navigate',
};

type HandledKey = keyof typeof handledKeys;

function isHandledKey(key: string): key is HandledKey {
  return Object.keys(handledKeys).includes(key);
}

export function handleKeyEvents<T extends HTMLElement>(
  handlers: KeyEventHandlers<T>
): React.KeyboardEventHandler<T> {
  // some element types should allow the default behavior
  const allowDefault = ['select', 'button'];

  return (e) => {
    const { key } = e;

    if (isHandledKey(key)) {
      const target = e.target as T;

      const action = handledKeys[key] as KeyEventAction<T>;
      const handler = handlers[action];

      if (handler) {
        if (allowDefault.indexOf(target.tagName.toLowerCase()) === -1) {
          e.preventDefault();
        }
        e.stopPropagation();
        handler(e);
      }
    }
  };
}
